import styled from "styled-components";
import { colors } from "styles/color-tokens";
import { getDisplayFeatureName } from "./plan-utils";
import { UpsellFeatureType } from "./types";
import QuokkaDoneImage from "./images/quokka-done.svg";
import { closeUpsellModal } from "actions/typed-modal";
import { useDispatch } from "react-redux";
import { UpsellHeader } from "./common-components";
import { Button } from "@/components/ui/button";

export const UpsellOrderSuccess = ({
  planName: _planName,
  feature,
  downgrade = false,
}: {
  planName: string;
  feature: UpsellFeatureType | "none" | "annual";
  downgrade: boolean;
}) => {
  const dispatch = useDispatch();
  return (
    <MainContainer>
      <QuokkaDoneImage />

      {feature === "annual" ? (
        <Header>
          Congratulations! Your plan has now been switched to annual billing.
        </Header>
      ) : (
        <Header>
          {downgrade
            ? `Your plan will change at your next billing period.`
            : `Your plan has now been changed. Click continue to use it now.`}
        </Header>
      )}
      {!downgrade && feature === "none" ? (
        <Text>Enjoy more awesome features with your new plan.</Text>
      ) : feature === "annual" ? (
        ""
      ) : (
        !downgrade && (
          <Text>
            Enjoy{" "}
            <HighlightedText>{getDisplayFeatureName(feature)}</HighlightedText>{" "}
            and more awesome features with your new plan.
          </Text>
        )
      )}

      <ButtonContainer>
        <Button
          style={{ width: "160px" }}
          variant="blue-primary"
          size="md"
          onClick={() => {
            dispatch(closeUpsellModal());
            window.location.reload(); // reload after plan change so we make sure this has applied
          }}
        >
          Continue
        </Button>
      </ButtonContainer>
    </MainContainer>
  );
};
const ButtonContainer = styled.div`
  margin-top: 24px;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled(UpsellHeader)`
  margin-top: 24px;
  margin-bottom: 8px;
`;

const Text = styled.div`
  //styleName: Web App/Paragraph 1 Regular;
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${colors.neutral800};
`;
const HighlightedText = styled.span`
  color: ${colors.primary500};
  font-weight: 600;
`;
